<template>
    <div class="TitleSection">
        <h1
            class="h1">
            {{ title }}
        </h1>
        <p
            v-if="text"
            class="h3 text--grey-dark"
            :id="title + '-subheading'"
            v-html="text"
        >
        </p>
    </div>
</template>

<script>
    export default {
        name: 'TitleSection',
        props: {
            title: {
                type: String,
                required: true
            },
            text: {
                type: [String, Boolean],
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .TitleSection {
        text-align: center;
    }
</style>
